module.exports = __webpack_public_path__ + "img/last-track-button-g.8ddd0afa.svg";